import { isNullOrUndefined } from 'src/utils/util';
import { ConfigExibicaoCamposService } from './../../../content/pages/services/config-exibicao-campos.service';
import { AuthenticationService } from './../../auth/authentication.service';
import { ParametrosConfiguracaoExibicaoCamposModel } from './parametros-configuracao-exibicao-campos.model';
import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {GridPreCargasService} from '../../../content/pages/components/roteirizacao/services/grid-pre-cargas.service';
import {
  ParamEspecificoLocalStorageService
} from '../../../content/pages/components/roteirizacao/services/param-especifico-local-storage.service';
import {ParametrosOcultoEnum} from '../../../content/pages/enums/parametros.enum';

@Component({
  selector: 'rot-configuracao-exibicao-campos',
  templateUrl: './configuracao-exibicao-campos.component.html',
  styleUrls: ['./configuracao-exibicao-campos.component.scss']
})
export class ConfiguracaoExibicaoCampos implements OnInit {

  eventoMudancaLista = new EventEmitter();
  eventoResetLista = new EventEmitter();
  checkboxController = false;
  configExibicaoCampos: any = {};
  parametros: ParametrosConfiguracaoExibicaoCamposModel;
  listaDeItensInterna = [];
  listaOriginal;
  resetandoAsConfiguracoes = false;
  private exibirTotalizadorUnidades: boolean;

  constructor(
    private configExibicaoCamposService: ConfigExibicaoCamposService,
    private authenticationService: AuthenticationService,
    private gridPreCargasService: GridPreCargasService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private paramEspecificoLocalStorageService: ParamEspecificoLocalStorageService) {
    this.configExibicaoCampos = this.data.configExibicaoCampos;
    this.parametros = this.data.parametros;

    this.listaDeItensInterna = this.parametros.dadosLista;
    this.listaOriginal = this.parametros.listaOriginal;
  }

  async ngOnInit() {
    await this.obterParametroExibirTotalizadorUnidades();
    if (!this.exibirTotalizadorUnidades) {
      this.listaDeItensInterna.forEach(item => {
        if (item.chaveCampo === 'totalUnidades') {
          item.check = false;
          item.ocultoPorParametro = true;
        }
      });
    }
  }

  salvar() {
    this.configExibicaoCamposService.salvar(this.configExibicaoCampos)
      .subscribe(result => {
        this.configExibicaoCampos = result;
        this.configExibicaoCamposService
          .getMensagensService()
          .exibaToastSucesso('Salvo com Sucesso!');
        this.emitirMudancaLista();
      });
  }

  deletar() {
    this.configExibicaoCamposService.delete(this.configExibicaoCampos)
      .subscribe(result => this.configExibicaoCamposService
        .getMensagensService()
        .exibaToastSucesso('Deletado com Sucesso!')
      );
  }

  alterouValorCheckBox() {
    this.emmiterDadosLista();
  }

  salvarConfiguracao() {

    const payload: any = {
      id: this.estaSalvo() ? this.configExibicaoCampos.id : undefined,
      usuario: {
        id: this.authenticationService.obtenhaUsuarioLogado().idUsuario
      },
      identificadorConfigExibicaoCampos: {
        codigo: this.parametros.chaveTela
      },
      moduloSistema: {
        codigo: 'ROTEIRIZADOR'
      }
    };

    payload.configExibicaoCamposItems = this.listaDeItens.map((v, index) => {
      let id;
      if (this.estaSalvo() && this.configExibicaoCampos.configExibicaoCamposItems) {
        const itemOriginal = this.configExibicaoCampos.configExibicaoCamposItems.find(i => i.chaveCampo === v.chaveCampo);
        id = itemOriginal ? itemOriginal.id : undefined;
      }

      return {
        id,
        exibir: v.check,
        ordem: index + 1,
        chaveCampo: v.chaveCampo
      };
    });

    this.configExibicaoCamposService.salvar(payload)
      .subscribe(result => {
        this.configExibicaoCampos = result;
        this.configExibicaoCamposService
          .getMensagensService()
          .exibaToastSucesso('Salvo com Sucesso!');
        this.emitirMudancaLista();
      });
  }

  private estaSalvo() {
    return !isNullOrUndefined(this.configExibicaoCampos) && !isNullOrUndefined(this.configExibicaoCampos.id);
  }

  resetarConfiguracao() {
    this.resetandoAsConfiguracoes = true;
    this.listaDeItens = this.listaOriginal;
    this.listaDeItens.forEach(d => d.check = d.showDefault);
    this.salvarConfiguracao();
  }

  marcarTodos() {
    this.checkboxController = !this.checkboxController;
    this.listaDeItens.forEach(d => d.check = this.checkboxController);
    this.emmiterDadosLista();
  }

  get obterLabelBotaoMarcarDesmarcarTodos() {
    return this.checkboxController ? 'Desmarcar Todos' : 'Marcar Todos';
  }

  get listaDeItens() {
    return this.listaDeItensInterna;
  }

  set listaDeItens(value) {
    this.listaDeItensInterna = value;
  }

  ordenarListaDrop() {
    this.emitirMudancaLista();
  }

  private emmiterDadosLista() {
    this.emitirMudancaLista();
  }


  private emitirMudancaLista() {
    const lista = [...this.listaDeItens];
    if (!this.resetandoAsConfiguracoes) {
      this.eventoMudancaLista.emit(lista.map(e => e.check = !e.visivel ? true : e.check));
    }

    if (lista && this.resetandoAsConfiguracoes) {
      this.resetandoAsConfiguracoes = false;
      if (this.parametros.chaveTela === 'GRID_ENTREGAS_PAINEL_CARREGAMENTO') {
        this.gridPreCargasService.alterouConfiguracaoGridPreCargasEvent.emit(lista);
      }
      if (this.parametros.chaveTela === 'GRID_PEDIDOS_PAINEL_CARREGAMENTO') {
        this.gridPreCargasService.alterouConfiguracaoGridPedidosEvent.emit();
      }
      if (this.parametros.chaveTela === 'GRID_CARREGAMENTOS_GRAVADOS') {
        this.eventoResetLista.emit([]);
      }

      if (this.parametros.chaveTela === 'GRID_DETALHES_CLIENTES') {
        this.eventoResetLista.emit([]);
      }
    } else {
      this.resetandoAsConfiguracoes = false;
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.listaDeItens, event.previousIndex, event.currentIndex);
    this.emitirMudancaLista();
  }

  private async obterParametroExibirTotalizadorUnidades() {
    await this.paramEspecificoLocalStorageService
      .getParametroEspecificoLocalStorage(ParametrosOcultoEnum.EXIBIR_TOTALIZADOR_QUANTIDADE_UNIDADES).then((param) => {
        this.exibirTotalizadorUnidades = param != null && param === 'S';
      });
  }
}
